var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3334 5.16644C14.0835 5.58308 12.4169 3.91654 12.8336 2.66663M12.7325 2.76773L10.0396 5.46054C8.86897 6.63122 8.03847 8.09805 7.63693 9.7042L7.50681 10.2247C7.46627 10.3868 7.61316 10.5337 7.77533 10.4932L8.2958 10.3631C9.90195 9.96153 11.3688 9.13103 12.5395 7.96035L15.2323 5.26754C15.5638 4.93604 15.75 4.48644 15.75 4.01763C15.75 3.0414 14.9586 2.25 13.9824 2.25C13.5136 2.25 13.064 2.43623 12.7325 2.76773Z",
    stroke: "#959598",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 2.25C8.2325 2.25 7.46501 2.33822 6.71282 2.51466C4.62976 3.00328 3.00328 4.62976 2.51466 6.71282C2.16178 8.21719 2.16178 9.78281 2.51466 11.2872C3.00328 13.3702 4.62976 14.9967 6.71283 15.4853C8.21719 15.8382 9.78281 15.8382 11.2872 15.4853C13.3702 14.9967 14.9967 13.3702 15.4853 11.2872C15.6618 10.535 15.75 9.76748 15.75 8.99998",
    stroke: "#959598",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEdit);
export default __webpack_public_path__ + "static/media/icon-edit.2f26c0f26972f3ce8b2ca6e5097f61db.svg";
export { ForwardRef as ReactComponent };